export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'trailer', getter: () => import(/* webpackChunkName: "gallery" */ 'components/bolt/gallery/gallery'), component: 'gallery', parent: 'boltHome' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "gallery" */ 'components/bolt/gallery/gallery'), component: 'gallery', parent: 'boltHome' },
	{ id: 'merch', getter: () => import(/* webpackChunkName: "text" */ 'components/bolt/text/text'), component: 'text', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
